import React from 'react';

interface DataEntryQuarterWarningModalProps {
  isOpen: boolean;
  currentQuarter: string;
  mostRecentQuarter: string;
  onProceed: () => void;
  onSwitchQuarter: () => void;
}

const DataEntryQuarterWarningModal: React.FC<DataEntryQuarterWarningModalProps> = ({
  isOpen,
  currentQuarter,
  mostRecentQuarter,
  onProceed,
  onSwitchQuarter,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <div className="mb-4">
          <div className="flex items-center justify-center mb-4">
            <div className="bg-orange-100 rounded-full p-3">
              <svg className="w-12 h-12 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
          <h3 className="text-xl font-bold text-center text-gray-900 mb-3">Data Entry Notice</h3>
          <p className="text-gray-700 text-center leading-relaxed">
            The last data has been entered in <strong className="text-sd-navy">{mostRecentQuarter}</strong>
          </p>
          <p className="text-gray-700 text-center leading-relaxed mt-3">
            You are currently in <strong className="text-orange-600">{currentQuarter}</strong>.
          </p>
          <div className="bg-orange-50 border border-orange-200 rounded p-3 mt-4">
            <p className="text-gray-700 text-center font-semibold">
              Do you wish to proceed with data entry in {currentQuarter}?
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-3 mt-6">
          <button
            type="button"
            onClick={onSwitchQuarter}
            className="w-full px-6 py-3 bg-sd-navy text-white rounded-lg font-semibold hover:bg-[#043661] transition-colors"
          >
            No, Proceed to {mostRecentQuarter}
          </button>
          <button
            type="button"
            onClick={onProceed}
            className="w-full px-6 py-3 bg-gray-500 text-white rounded-lg font-semibold hover:bg-gray-600 transition-colors"
          >
            Yes, Continue in {currentQuarter}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataEntryQuarterWarningModal;
